// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"advantages-cards_wrapper__4294G","grid":"advantages-cards_grid__NXF8E","item":"advantages-cards_item__IvSJv"};